import React from "react";
import Seo from "../../components/seo/seo";
import hireAIDeveloperDetails from "../../constant/hires/ai-automation-developer.json";
import HireDeveloperDetails from "../../components/hire-developer-details/HireDeveloperDetails";

const breadcrumbList = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "InfyOm",
      item: "https://infyom.com",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Services",
      item: "https://infyom.com/services",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Hire AI Automation Developers",
      item: "https://infyom.com/services/hire-ai-automation-developers",
    },
  ],
};

const HireLaravelDevelopers = () => {
  const laravelDeveloperProps = {
    title: hireAIDeveloperDetails.title,
    description: hireAIDeveloperDetails.description,
    developmentServices: hireAIDeveloperDetails.developmentServices,
    whyHireInfyOm: hireAIDeveloperDetails.whyHireInfyOm,
    hireDedicatedDevelopers: hireAIDeveloperDetails.hireDedicatedDevelopers,
    footerText: hireAIDeveloperDetails.footerText,
    dropdownName: hireAIDeveloperDetails.dropdownName,
  };

  return (
    <>
      <Seo
        title={hireAIDeveloperDetails.seoTitle}
        description="Hire n8n Automation Developers | InfyOm Technologies"
        breadcrumbList={breadcrumbList}
      />
      <HireDeveloperDetails {...laravelDeveloperProps} />
    </>
  );
};

export default HireLaravelDevelopers;
